(function() {
  var slice = [].slice,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.register = function(module) {
    return module.factory('Core.Services.MapLayers.Base', [
      '$http', 'Core.Services.Map', '$q', function() {
        var args;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return {
          "new": function() {
            var service;
            service = (function(func, args, ctor) {
              ctor.prototype = func.prototype;
              var child = new ctor, result = func.apply(child, args);
              return Object(result) === result ? result : child;
            })(exports.Base, args, function(){});
            service.geojson = null;
            return service;
          }
        };
      }
    ]);
  };

  exports.Base = (function() {
    function Base(http, mapService, promise1) {
      this.http = http;
      this.mapService = mapService;
      this.promise = promise1;
      this.propertyTable = bind(this.propertyTable, this);
      this.getGeoJSON = bind(this.getGeoJSON, this);
      this.makeMapLayer = bind(this.makeMapLayer, this);
      this._getStyle = bind(this._getStyle, this);
      this.setOpacity = bind(this.setOpacity, this);
      this.hide = bind(this.hide, this);
      this.display = bind(this.display, this);
      void 0;
    }

    Base.prototype.display = function(query, layer, styling) {
      var promise;
      if (styling == null) {
        styling = {};
      }
      if (this.geojson == null) {
        return this._display(layer, this.url, query, styling).then((function(_this) {
          return function(response) {
            _this.geojson = response;
            if (_this.opacity != null) {
              _this.setOpacity(_this.opacity);
            }
            return response;
          };
        })(this), (function(_this) {
          return function(response) {
            return _this.promise.reject(response);
          };
        })(this));
      } else {
        promise = this.promise.defer();
        layer.addLayer(this.geojson);
        this.layer_added_to = layer;
        promise.resolve(this.geojson);
        return promise.promise;
      }
    };

    Base.prototype.hide = function(layer) {
      if (this.geojson != null) {
        return layer.removeLayer(this.geojson);
      }
    };

    Base.prototype.setOpacity = function(value) {
      var fill, line;
      this.opacity = value;
      if (this.geojson == null) {
        return;
      }
      fill = (value / 100).toFixed(2);
      line = ((value + 100) / 200).toFixed(2);
      return this.geojson.eachLayer(function(l) {
        return l.setStyle({
          fillOpacity: fill,
          opacity: line
        });
      });
    };

    Base.prototype._getStyle = function() {
      return $.extend({}, {
        fillColor: '#00FF00'
      }, {
        color: '#000000',
        opacity: 0.75,
        fillOpacity: 0.3,
        weight: 2
      });
    };

    Base.prototype._display = function(layer, url, options, style, eachFeature) {
      if (eachFeature == null) {
        eachFeature = null;
      }
      return this.http.post(url, options).then((function(_this) {
        return function(response) {
          var gj, json;
          json = _this.getGeoJSON(response);
          if (json == null) {
            return _this.promise.reject(response);
          }
          gj = _this.makeMapLayer(layer, json, style, eachFeature);
          return response.json_layer = gj;
        };
      })(this));
    };

    Base.prototype.makeMapLayer = function(layer, json, style, eachFeature) {
      var gj;
      if (style == null) {
        style = null;
      }
      if (eachFeature == null) {
        eachFeature = null;
      }
      gj = this.mapService.getLeaflet().geoJson(json, {
        style: (function(_this) {
          return function(feature) {
            var st;
            st = $.extend(_this._getStyle(), style);
            if (feature.mapProperties != null) {
              st = $.extend(st, feature.mapProperties);
            }
            st = $.extend(st, feature.properties);
            return st;
          };
        })(this),
        onEachFeature: (function(_this) {
          return function(ft, layer) {
            layer.feature = ft;
            if (eachFeature != null) {
              return eachFeature(ft, layer);
            } else {
              return _this.propertyTable(ft, layer);
            }
          };
        })(this)
      });
      this.geojson = gj;
      this.layer_added_to = layer;
      layer.addLayer(gj);
      return gj;
    };

    Base.prototype.getGeoJSON = function(response) {
      var json;
      if (response.data.data == null) {
        return json = response.data;
      } else {
        return json = response.data.data;
      }
    };

    Base.prototype.propertyTable = function(ft, layer) {
      var info, k, ref, v;
      if (ft.properties != null) {
        info = "<table class='table table-condensed margin-top-22'>";
        ref = ft.properties;
        for (k in ref) {
          v = ref[k];
          info += "<tr><td><strong>" + k + "</strong></td><td>" + v + "</td></tr>";
        }
        info += '</table>';
      }
      return layer.bindPopup(info);
    };

    return Base;

  })();

}).call(this);
